<template>
<el-dialog
  :visible.sync="dialogVisible"
  width="80%"
  top="10vh"
  >
  <p slot="title">
    <!-- 模型{{echarttitle?echarttitle.name:""}} -->
      {{changeIdToName(echarttitle.name)}}
    <excel-download
        style="float:right;margin-top:20px"
        type="success"
        :excelParam="excelParam"
        :data="tempechartdata"
        :title="echarttitle?`模型${changeIdToName(echarttitle.name)}的数据`:'请输入文件名'"
    ></excel-download>
  </p>
  <!-- {{echartData[0]}} -->
  
     <!-- <img :src="imageSrc" alt=""> -->
    <ve-line id="chartLine" :data="echartData"  :settings="chartSettings" :title="title" :legend-visible="false" :yAxis="yAxis" ></ve-line>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogVisible = false"></el-button> -->
      <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      <!-- <el-button type="primary" @click="setImage()">截图</el-button> -->
    </span>
</el-dialog>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props:["tempechartdata","echarttitle"],
  data () {
    this.title = {
      // text: "Main Title",
      // subtext: "Sub Title",
      // left: "center",
      // top: "top",
    }
    this.yAxis = {
      name:"电压"
    }
    
    this.chartSettings = {
      xAxisType: "value",//横轴的数据类型
      // xAxisName: "时间",
      // yAxisName: "电压",
    }
    return {
      imageSrc:'',
      dialogVisible:false,
      echartData: {
        columns: ['时间', '电压'],
        rows: [],
      },
      iteration:200, //把一个周期分割成这么多小块
      // maxU:5, //电压的最大值 峰值
      // timeT:Math.PI*3, //周期

      excelParam:{ //导出excel的head
          head: [
          "时间",
          "电压",
          ],
          filter: [
          "时间",
          "电压",
          ]
      },
    }
  },
 
  created(){
    // console.log(Math.sin(Math.PI).toFixed(2));
    // this.initechart();
  },
  methods: {
    setImage () {
      let canvas = document.getElementsByTagName('canvas')[0];
      let name = this.echarttitle?this.echarttitle.name:""; 
      // alert(name)
      if(name==17){ //信号发生器
        localStorage.setItem('17',canvas.toDataURL("image/jpeg", 1))
      }if(name==18){ //示波器
        localStorage.setItem('18',canvas.toDataURL("image/jpeg", 1))
      }
      return
        let elementId = "chartLine";
        var canvas2 = document.createElement("canvas");
        let _canvas = document.getElementById(elementId);
        var w = parseInt(window.getComputedStyle(_canvas).width);
        var h = parseInt(window.getComputedStyle(_canvas).height);
        //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了  
        canvas2.width = w+280;
        canvas2.height = h ;
        canvas2.style.width = w +280+ "px";
        canvas2.style.height = h + "px";
        var context = canvas2.getContext("2d");
        // context.scale(2, 2);
        html2canvas(document.getElementById(elementId,{ useCORS: true, allowTaint: true }), {
                canvas: canvas2
            }).
            then(canvas=> {
                let name = echarttitle?echarttitle.name:"";
                // that.imageSrc = canvas.toDataURL("image/jpeg", 1)
                alert(name)
                if(name==17){ //信号发生器
                  localStorage.setItem('17',canvas.toDataURL("image/jpeg", 1))
                }if(name==18){ //示波器
                  localStorage.setItem('18',canvas.toDataURL("image/jpeg", 1))
                }
            }
        );
    },
    // initechart(){
    //   this.chartData.rows = [];
    //   const iteration = this.iteration;
    //   var timeT = 1/this.echartData.f; //周期
    //   // timeT = timeT*2*Math.PI; //周期乘以2PI
    //   console.log("周期",timeT)
    //   for(let i=0; i<iteration; i++){
    //     let row = {'时间': '', '电压': ''};
    //     row.时间 = i/iteration*timeT;
    //     row.电压 = Math.sin(row.时间/timeT*2*Math.PI)*this.echartData.U0;
    //     this.chartData.rows.push(row)
    //   }
    //   console.log(this.chartData.rows[0])
    // },
    changedialogVisible(){
      this.dialogVisible = !this.dialogVisible;
      if(this.dialogVisible){
        // console.log("重绘表格",this.tempechartdata)
        // this.initechart(); //
        this.echartData.rows = this.tempechartdata;
        setTimeout(()=>{
          this.setImage()
        },2000)
      }
    }
  },
  
}
</script>


// WEBPACK FOOTER //
// src/components/ef/echart.vue